/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc
 */
import * as References from './AccessDelegationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc#inviteUser
 */
export const INVITE_USER_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AccessDelegationRpc_inviteUser';
export const INVITE_USER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: INVITE_USER_MUTATION_FIELD_NAME,
  args: ['invitedEmail', 'userRole', 'redirectSlug', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.inviteUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc#acceptInvitation
 */
export const ACCEPT_INVITATION_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AccessDelegationRpc_acceptInvitation';
export const ACCEPT_INVITATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ACCEPT_INVITATION_MUTATION_FIELD_NAME,
  args: ['email', 'password', 'firstName', 'lastName', 'token', 'accountId', 'authMethod'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.acceptInvitationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc#listUserInvitations
 */
export const LIST_USER_INVITATIONS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AccessDelegationRpc_listUserInvitations';
export const LIST_USER_INVITATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_USER_INVITATIONS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'offset', 'limit', 'sortField', 'sortDirection', 'statuses', 'roles', 'emailSearch'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.listUserInvitationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc#uninviteUser
 */
export const UNINVITE_USER_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AccessDelegationRpc_uninviteUser';
export const UNINVITE_USER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNINVITE_USER_MUTATION_FIELD_NAME,
  args: ['id', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.uninviteUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AccessDelegationRpc#changeUserRole
 */
export const CHANGE_USER_ROLE_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_AccessDelegationRpc_changeUserRole';
export const CHANGE_USER_ROLE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CHANGE_USER_ROLE_MUTATION_FIELD_NAME,
  args: ['id', 'role', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.changeUserRoleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});